<template>
  <div class="cartoon">
        <Navigation></Navigation> 
        <div class="bg"></div>
        <div class="mb_cartoon_bg"></div>
        <img src="../assets/images/back_btn.png" alt="" class="back_btn" @click="goback">
        <img src="../assets/images/cartoon_title.png" alt="" class="cartoon_title">
        <ul class="cartoon_content clearfix">
            <li class="cartoon_li"  v-for="(item,index) in cartoonList" :key="index" @click="goDetail(item)">
                <img :src="item.icon" alt="" class="icon">
                <div class="title">{{item.title}}</div>
                <!-- <img src="../assets/images/cartoon_title_01.png" alt="" class="title"> -->
            </li>
        </ul>
        <div class="page">
                <img src="../assets/images/front.png" alt=""  @click="goPage('prev')" class="page_prev" v-show="pageNum>1">
                <div class="pageNum" v-show="totalPages>1">
                    {{pageNum}}
                </div>
                <img src="../assets/images/back.png" alt=""  @click="goPage()" class="page_back" v-show="pageNum<totalPages">
        </div>
        
  </div>
</template>

<script>
import Navigation from '../components/navigation'
import api from '@/api'
export default {
  name: 'cartoon',
    components:{
      Navigation
  },
  data(){
      return{
         isActiveNewsTitle:0,
         pageNum:1,
        pageSize:6,
        totalPages:1,
        cartoonList: []
      }
  },
  mounted(){
    this.getCartoonList()
  },
  methods:{ 
      goback(){
        this.$router.push("/")
      },
      getCartoonList(){
        api.getCartoonList(JSON.stringify({
            pageSize:this.pageSize,
            pageNum:this.pageNum
        }))
        .then((res) => {
            this.loading = false
            let resData = res.data
            if(resData.code === 200){
                this.cartoonList = resData.data
                this.totalPages = resData.totalPages
            }
        })
    },
      goDetail(item){
          this.$router.push(`/cartoonDetail?cId=${item.c_id}`)
      },
       // 分页
        goPage(param){
            if(param === 'prev'){
                if(this.pageNum-1<=0) return false;
                this.pageNum = this.pageNum-1
                this.getCartoonList()
            }else{
                if(this.pageNum+1>this.totalPages) return false;
                this.pageNum = this.pageNum+1
                this.getCartoonList()
            }
        },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
     .bg{
        background: url('../assets/images/news_bg.png') no-repeat;
        background-attachment: fixed;
        background-repeat: no-repeat;
        background-size: cover;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
    }
    .mb_cartoon_bg{
        background: url('../assets/images/mb_news_bg.png') no-repeat;
        background-repeat: no-repeat;
        background-size: cover;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        display: none;
    }
    .cartoon{
        width: 100%;
        height: 100%;
        text-align: left;
    }
    .back_btn{
        width:232px;
        margin-top: 150px;
        margin-left: 80px;
        cursor: pointer;
          visibility: hidden;
    }
    .cartoon_title{
        width:600px;
        margin-top: 300px;
        margin-left:1200px;
    }
    .cartoon_content{
        width: 70%;
        position: relative;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
        .cartoon_li{
            position: relative;
            width: 500px;
            height: 380px;
            padding: 0px 0;
            background: url('../assets/images/cartoon_border.png');
            background-size: 100% 100%;
            float: left;
            margin: 150px;
            cursor: pointer;
            .icon{
                width: 90%;
                margin: 30px 10px;
            }
            .title{
                text-align: center;
                font-size: 80px;
                font-weight: 700;
                color: #000;
            }
            // .titlefn(@width: 400px,@left:1vw) {
            //         .title{
            //         width: @width;
            //         // top: @imgTop
            //         left: @left;
            //     }
            // }
            // .icon{
            //     width: 400px;
            //     height:300px;
            // }
            // .title{
            //     position: absolute;
            //     bottom: -80px;
            //     left:30px;
            //  }
            // &:nth-child(1){
            //     .titlefn()
            // }
            // &:nth-child(2){
            //     .titlefn(450px,0)
            // }
            // &:nth-child(3){
            //     .titlefn(760px,-100px)
            // }
            // &:nth-child(4){
            //     .titlefn(600px,-80px)
            // }
            // &:nth-child(5){
            //     .titlefn(850px,-180px)
            // }
        }
    }
    .page{
            width: 100%;
            // position: absolute;
            // top: 2000px;
            // left: 50%;
            margin-top: 300px;
            margin-bottom: 200px;
            text-align: center;
            // transform: translateX(-50%);
            img{
                width: 120px;
                vertical-align: sub;
                cursor: pointer;
            }
            .pageNum{
                display:inline-block;
                width: 100px;
                height: 100px;
                color: #000;
                font-size: 80px;
                margin: 0 400px;
            }
        }
   
    
// 移动端
@media screen and (max-width: 750px) {
    .news_tags{
        li{
            font-size: 30px;
        }
    }
    .bg{
        display: none;
    }
    .mb_cartoon_bg{
        display: block;
    }
    .back_btn{
        width: 400px;
        margin-top: 400px;
    }
    .cartoon_title{
        width: 900px;
        margin-left: 900px;
        margin-top: 600px;
    }
    .titlefn(@width: 700px,@left:1vw) {
        .title{
            width: @width;
            // top: @imgTop
            left: @left;
        }
    }
    .cartoon_content{
        width: 80%;
        .cartoon_li{
            width: 950px;
            height: 700px;
            margin: 250px;
            text-align: center;
            .icon{
                width: 88%;
                margin: 50px 10px;
            }
            .title{
                font-size: 150px;
            }
            // img.icon{
            //     width: 780px;
            //     height: 600px;
            // }
            // .title{
            //     bottom:-180px;
            // }
            // &:nth-child(1){
            //     .titlefn()
            // }
            // &:nth-child(2){
            //     .titlefn(760px,50px)
            // }
            // &:nth-child(3){
            //     .titlefn(1200px,-120px)
            // }
            // &:nth-child(4){
            //     .titlefn(1000px,-80px)
            // }
            // &:nth-child(5){
            //     .titlefn(1350px,-200px)
            // }
        }
    }
    .page{
            width: 90%;
            margin-top: 550px;
            img{
                position: absolute;
                width: 400px;
            }
            .page_prev{
                left: 300px;
            }
            .page_back{
                right:400px;
            }
            .pageNum{
                font-size: 200px;
                // display: none;
            }
    }
}
</style>
